const RowsPerPageOption = {
  SMALL: 25,
  MEDIUM: 50,
  LARGE: 100,
};

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [
  RowsPerPageOption.SMALL,
  RowsPerPageOption.MEDIUM,
  RowsPerPageOption.LARGE,
];

export const defaultMultilineTextCellTypographyProps = {
  className: 'table-cell__content_text',
  color: 'text.secondary',
  variant: 'regular16',
};

export const defaultMultilineTextCellCDSProps = {
  customStyles: () => ({ whiteSpace: 'normal', wordBreak: 'break-word' }),
};

/** The hover state of a row that is neither disabled nor drag-locked; append to a row selector. */
export const ENABLED_ROW_HOVER_SELECTOR =
  ':not([data-row-disabled="true"]):not([data-row-drag-disabled="true"]):hover';
